import { render, staticRenderFns } from "./ShareBox.vue?vue&type=template&id=7bef052f&scoped=true"
import script from "./ShareBox.vue?vue&type=script&lang=js"
export * from "./ShareBox.vue?vue&type=script&lang=js"
import style0 from "./ShareBox.vue?vue&type=style&index=0&id=7bef052f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bef052f",
  null
  
)

export default component.exports